"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const antd_1 = require("antd");
const react_query_1 = require("@tanstack/react-query");
const rte_1 = require("@mantine/rte");
const FileUpload_1 = __importDefault(require("../../common/FileUpload"));
const Feedback_1 = __importDefault(require("../../common/Feedback"));
const configItems_1 = require("../../../services/configItems");
const models_1 = require("../../../services/models");
const useMutateWrapper_1 = require("../../../hooks/useMutateWrapper");
const upload_1 = require("../../../utils/upload");
const modelPropertyTypes_1 = __importDefault(require("../../../constants/modelPropertyTypes"));
const queryKeys_1 = __importDefault(require("../../../constants/queryKeys"));
const validationMessages_1 = __importDefault(require("../../../constants/validationMessages"));
const richTextEditor_1 = __importDefault(require("../../../utils/richTextEditor"));
const Icon_1 = __importDefault(require("../../../components/common/Icon"));
const { Title } = antd_1.Typography;
const { Item, useForm, useWatch } = antd_1.Form;
const { Option } = antd_1.Select;
const { Panel } = antd_1.Collapse;
const { TEXT, RICH_TEXT, STATIC, BOOLEAN } = modelPropertyTypes_1.default;
const NewConfigItem = ({ parent, configId, tenantId, show, activeLocales, handleDrawer }) => {
    var _a;
    const qc = (0, react_query_1.useQueryClient)();
    const [newConfigItemForm] = useForm();
    const formModelIdValue = useWatch('modelId', newConfigItemForm);
    const [configMeta, setConfigMeta] = (0, react_1.useState)({});
    const [assets, setAssets] = (0, react_1.useState)([]);
    const [showAlert, setShowAlert] = (0, react_1.useState)(false);
    const [codeViewList, setCodeViewList] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        // if showAlert is true then scroll into view
        const formElement = document.getElementById('new-config-item-form');
        showAlert && (formElement === null || formElement === void 0 ? void 0 : formElement.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    }, [showAlert]);
    const { isLoading: isModelsDataLoading, data: modelsData } = (0, react_query_1.useQuery)({
        queryKey: [queryKeys_1.default.MODELS.ALL],
        queryFn: (0, models_1.getModels)(),
        enabled: show,
    });
    const models = modelsData === null || modelsData === void 0 ? void 0 : modelsData.map(({ modelId, modelName }) => ((0, jsx_runtime_1.jsx)(Option, Object.assign({ value: modelId }, { children: modelName }), modelId)));
    // pull the model properties for the model used for customization
    const { isLoading: isModelPropsLoading, data: modelProps } = (0, react_query_1.useQuery)({
        queryKey: [queryKeys_1.default.MODELS.MODEL_DETAILS, { modelId: formModelIdValue }],
        queryFn: (0, models_1.getModel)(formModelIdValue),
        enabled: !!formModelIdValue,
    });
    // creating structure of initial config meta
    const createInitialState = (properties) => {
        const newConfigMeta = properties
            .reduce((acc, { propertyType, propertyName, isLocalizable }) => {
            if (isLocalizable) {
                activeLocales.forEach(({ code }) => {
                    acc[`${propertyType}#${propertyName}#${code}`] = '';
                });
            }
            else {
                acc[`${propertyType}#${propertyName}`] = '';
            }
            return acc;
        }, {});
        setConfigMeta(newConfigMeta);
        setAssets(Object.keys(newConfigMeta)
            .filter((nCM) => nCM.split('#')[0] === STATIC)
            .map((key) => ({ key, file: '', isUploading: false })));
    };
    // call createInitialState function when model is changed from dropdown
    (0, react_1.useEffect)(() => {
        (modelProps === null || modelProps === void 0 ? void 0 : modelProps.properties) && createInitialState(modelProps.properties);
    }, [formModelIdValue, modelProps]);
    const handleFileUpload = (file, propertyName) => {
        setAssets(assets.map((asset) => (asset.key === propertyName
            ? Object.assign(Object.assign({}, asset), { file: file.status === 'removed' ? '' : file }) : asset)));
        setConfigMeta(Object.assign(Object.assign({}, configMeta), { [propertyName]: file.status === 'removed' ? '' : file.uid }));
    };
    const renderNormalFields = ({ propertyId, propertyName, propertyType }) => {
        var _a;
        const configMetaKey = `${propertyType}#${propertyName}`;
        switch (propertyType) {
            case TEXT: {
                return ((0, jsx_runtime_1.jsx)(Item, Object.assign({ label: propertyName }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { value: configMeta[configMetaKey], onChange: (e) => setConfigMeta(Object.assign(Object.assign({}, configMeta), { [configMetaKey]: e.target.value })) }) }), propertyId));
            }
            case RICH_TEXT: {
                return ((0, jsx_runtime_1.jsxs)(Item, Object.assign({ label: propertyName }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, { className: 'rte-codeview-toggle-button', icon: (0, jsx_runtime_1.jsx)(Icon_1.default, { iconName: 'code' }), onClick: () => {
                                codeViewList.includes(configMetaKey)
                                    ? setCodeViewList(codeViewList.filter((codeView) => codeView !== configMetaKey))
                                    : setCodeViewList([...codeViewList, configMetaKey]);
                            } }), codeViewList.includes(configMetaKey) ? ((0, jsx_runtime_1.jsx)(antd_1.Card, Object.assign({ style: { backgroundColor: 'whitesmoke' } }, { children: configMeta[configMetaKey] }))) : ((0, jsx_runtime_1.jsx)(rte_1.RichTextEditor, { controls: [
                                ['bold', 'italic', 'underline'],
                                ['h1', 'h2', 'h3'],
                                ['unorderedList', 'orderedList'],
                                ['link'],
                            ], value: configMeta[configMetaKey], onChange: (value) => setConfigMeta(Object.assign(Object.assign({}, configMeta), { [configMetaKey]: value })) }))] }), propertyId));
            }
            case STATIC: {
                return ((0, jsx_runtime_1.jsx)(Item, Object.assign({ label: propertyName }, { children: (0, jsx_runtime_1.jsx)(FileUpload_1.default, { name: configMetaKey, loading: ((_a = assets
                            .filter(({ key }) => key === configMetaKey)[0]) === null || _a === void 0 ? void 0 : _a.isUploading) === true, loadingText: 'Uploading...', setData: (file, pName) => handleFileUpload(file, pName) }) }), propertyId));
            }
            case BOOLEAN: {
                return ((0, jsx_runtime_1.jsx)(Item, Object.assign({ valuePropName: 'checked' }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Checkbox, Object.assign({ onChange: (e) => setConfigMeta(Object.assign(Object.assign({}, configMeta), { [configMetaKey]: e.target.checked })) }, { children: [propertyName, "?"] })) }), propertyId));
            }
            default: return null;
        }
    };
    const renderLocaleFields = ({ propertyId, propertyName, propertyType }, { code }) => {
        var _a;
        const configMetaKey = `${propertyType}#${propertyName}#${code}`;
        switch (propertyType) {
            case TEXT: {
                return ((0, jsx_runtime_1.jsx)(Item, Object.assign({ label: propertyName }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { value: configMeta[configMetaKey], onChange: (e) => setConfigMeta(Object.assign(Object.assign({}, configMeta), { [configMetaKey]: e.target.value })) }) }), propertyId));
            }
            case RICH_TEXT: {
                return ((0, jsx_runtime_1.jsxs)(Item, Object.assign({ label: propertyName }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, { className: 'rte-codeview-toggle-button', icon: (0, jsx_runtime_1.jsx)(Icon_1.default, { iconName: 'code' }), onClick: () => {
                                codeViewList.includes(configMetaKey)
                                    ? setCodeViewList(codeViewList.filter((codeView) => codeView !== configMetaKey))
                                    : setCodeViewList([...codeViewList, configMetaKey]);
                            } }), codeViewList.includes(configMetaKey) ? ((0, jsx_runtime_1.jsx)(antd_1.Card, Object.assign({ style: { backgroundColor: 'whitesmoke' } }, { children: configMeta[configMetaKey] }))) : ((0, jsx_runtime_1.jsx)(rte_1.RichTextEditor, { controls: [
                                ['bold', 'italic', 'underline'],
                                ['h1', 'h2', 'h3'],
                                ['unorderedList', 'orderedList'],
                                ['link'],
                            ], value: configMeta[configMetaKey], onChange: (value) => setConfigMeta(Object.assign(Object.assign({}, configMeta), { [configMetaKey]: value })) }))] }), propertyId));
            }
            case STATIC: {
                return ((0, jsx_runtime_1.jsx)(Item, Object.assign({ label: propertyName }, { children: (0, jsx_runtime_1.jsx)(FileUpload_1.default, { name: configMetaKey, loading: ((_a = assets
                            .filter(({ key }) => key === configMetaKey)[0]) === null || _a === void 0 ? void 0 : _a.isUploading) === true, loadingText: 'Uploading...', setData: (file, pName) => handleFileUpload(file, pName) }) }), propertyId));
            }
            default: return null;
        }
    };
    const renderFields = () => {
        var _a, _b;
        // lMP is model properties where isLocalizable is true
        const lMP = ((_a = modelProps === null || modelProps === void 0 ? void 0 : modelProps.properties) !== null && _a !== void 0 ? _a : []).filter(({ isLocalizable }) => isLocalizable);
        // nLMP is model properties where isLocalizable is false
        const nLMP = ((_b = modelProps === null || modelProps === void 0 ? void 0 : modelProps.properties) !== null && _b !== void 0 ? _b : []).filter(({ isLocalizable }) => !isLocalizable);
        if (lMP || nLMP) {
            lMP.sort((a, b) => a.propertyName.localeCompare(b.propertyName));
            nLMP.sort((a, b) => a.propertyName.localeCompare(b.propertyName));
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [nLMP.length > 0 && nLMP.map((property) => renderNormalFields(property)), lMP.length > 0 && ((0, jsx_runtime_1.jsx)(antd_1.Collapse, Object.assign({ accordion: true }, { children: activeLocales.map((locale) => ((0, jsx_runtime_1.jsx)(Panel, Object.assign({ header: locale.localeName }, { children: lMP.map((property) => renderLocaleFields(property, locale)) }), locale.localeId))) })))] }));
        }
    };
    const closeForm = () => {
        newConfigItemForm.resetFields();
        setShowAlert(false);
        handleDrawer(false);
    };
    // secondary action on drawer
    const closeDrawer = () => {
        const formConfigItemNameValue = newConfigItemForm.getFieldValue('configItemName');
        const isFormEmpty = !formConfigItemNameValue && Object.values(configMeta).every((value) => !value);
        isFormEmpty ? closeForm() : setShowAlert(true);
    };
    const onErrorCb = () => antd_1.message.error('Some error happened!');
    const onSuccessCb = () => {
        antd_1.message.success('Config Item created successfully!');
        newConfigItemForm.resetFields();
        qc.invalidateQueries({ queryKey: [queryKeys_1.default.CONFIGURATIONS.CONFIG_DETAILS] });
        qc.invalidateQueries({ queryKey: [`${queryKeys_1.default.CONFIGURATIONS.CHILD_ITEMS}-${parent}`] });
        handleDrawer(false);
    };
    const { isLoading: isFormSubmitting, onFormSubmit } = (0, useMutateWrapper_1.useMutateWrapper)('create-config-item', configItems_1.createConfigItem, { onSuccessCb, onErrorCb });
    const configMetaObject = () => Object.keys(configMeta)
        .reduce((acc, key) => {
        const [type, name, localeCode] = key.split('#');
        if (localeCode) {
            switch (type) {
                case RICH_TEXT: {
                    acc[name] = Object.assign(Object.assign({}, acc[name]), { [localeCode]: (0, richTextEditor_1.default)(configMeta[key]) });
                    break;
                }
                default: {
                    acc[name] = Object.assign(Object.assign({}, acc[name]), { [localeCode]: configMeta[key] });
                    break;
                }
            }
        }
        else {
            switch (type) {
                case RICH_TEXT: {
                    acc[name] = (0, richTextEditor_1.default)(configMeta[key]);
                    break;
                }
                case BOOLEAN: {
                    acc[name] = configMeta[key] || false;
                    break;
                }
                default: {
                    acc[name] = configMeta[key];
                    break;
                }
            }
        }
        return acc;
    }, {});
    const configMetaForFile = () => __awaiter(void 0, void 0, void 0, function* () {
        const assetPath = {};
        try {
            const results = yield Promise.allSettled(assets.filter(({ file }) => file)
                .map(({ file, key }) => __awaiter(void 0, void 0, void 0, function* () {
                const fileName = `${(0, upload_1.nanoid)()}-${file.name}`;
                setAssets(assets
                    .filter((asset) => asset.file)
                    .map((asset) => (Object.assign(Object.assign({}, asset), { isUploading: true }))));
                const preSignedUrl = yield (0, upload_1.generatePresignedUrl)(tenantId, fileName);
                const success = yield (0, upload_1.uploadFile)(preSignedUrl, file);
                if (success) {
                    antd_1.message.success(`${file.name} uploaded successfully!`);
                    assetPath[key] = {
                        content_type: file.type,
                        file_size: file.size,
                        filename: file.name,
                        is_dir: false,
                        url: `${upload_1.assetBucketUrl}/${tenantId}/${fileName}`,
                    };
                }
                else {
                    antd_1.message.error(`${file.name} failed to upload.`);
                    throw new Error();
                }
            })));
            if (results.every((result) => result.status === 'fulfilled')) {
                Object.keys(configMeta).filter((cM) => cM.split('#')[0] === STATIC)
                    .forEach((key) => {
                    if (configMeta[key] && assetPath[key])
                        configMeta[key] = assetPath[key];
                });
                return true;
            }
            return false;
        }
        catch (error) {
            console.error(error);
            return false;
        }
        finally {
            setAssets(assets.map((asset) => (Object.assign(Object.assign({}, asset), { isUploading: false }))));
        }
    });
    const handleModelSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            (yield configMetaForFile()) && onFormSubmit({ parent, configId, configMeta: configMetaObject() })(values);
        }
        catch (error) {
            console.error(error);
        }
    });
    const handleSubmit = () => newConfigItemForm.validateFields()
        .then((values) => __awaiter(void 0, void 0, void 0, function* () { return handleModelSubmit(values); }))
        .catch(() => false);
    return ((0, jsx_runtime_1.jsx)(antd_1.Drawer, Object.assign({ destroyOnClose: false, title: ((0, jsx_runtime_1.jsx)(Title, Object.assign({ level: 4, style: { color: 'var(--color-primary-dark)', margin: 0 } }, { children: "New Configuration Item" }))), width: 600, onClose: closeDrawer, visible: show, extra: ((0, jsx_runtime_1.jsxs)(antd_1.Space, { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, Object.assign({ disabled: isFormSubmitting || assets.some(({ isUploading }) => isUploading), onClick: closeDrawer }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(antd_1.Button, Object.assign({ type: 'primary', disabled: isFormSubmitting || assets.some(({ isUploading }) => isUploading), onClick: handleSubmit }, { children: "Save" }))] })) }, { children: (0, jsx_runtime_1.jsx)(antd_1.Spin, Object.assign({ spinning: isFormSubmitting }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Form, Object.assign({ scrollToFirstError: true, layout: 'vertical', form: newConfigItemForm, name: 'new-config-item-form' }, { children: [showAlert && (0, jsx_runtime_1.jsx)(Feedback_1.default, { handleNo: () => setShowAlert(false), handleYes: closeForm }), (0, jsx_runtime_1.jsx)(Item, Object.assign({ name: 'configItemName', label: 'Name', rules: [{ required: true, message: validationMessages_1.default.required }] }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { showCount: true, maxLength: 250 }) })), (0, jsx_runtime_1.jsx)(Item, Object.assign({ name: 'modelId', label: 'Model', rules: [{ required: true, message: validationMessages_1.default.required }] }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, Object.assign({ showSearch: true, filterOption: (input, option) => option.children
                                .toLowerCase().includes(input.toLowerCase()), loading: isModelsDataLoading }, { children: models })) })), formModelIdValue && ((0, jsx_runtime_1.jsxs)(antd_1.Spin, Object.assign({ spinning: isModelPropsLoading, tip: 'Loading...' }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Divider, {}), (0, jsx_runtime_1.jsx)(Title, Object.assign({ level: 5 }, { children: "Properties" })), ((_a = modelProps === null || modelProps === void 0 ? void 0 : modelProps.properties) !== null && _a !== void 0 ? _a : []).length > 0 ? renderFields() : 'No Properties Available'] })))] })) })) })));
};
exports.default = NewConfigItem;
